<template>
  <material-content :type="type" :projection="projection" :title="title" />
</template>

<script>
import { MATERIALS_TYPES } from '@/enums/MaterialsTypes';
import MaterialContent from './UIComponents/MaterialContent.vue';

export default {
  components: {
    MaterialContent,
  },
  data() {
    return {
      type: MATERIALS_TYPES.server.value,
      projection: 'materialServerSummary',
      title: 'Liste des serveurs',
    };
  },
};
</script>
